import { BeaconPriorityCd, BeaconSourceCd, BeaconTypeCd } from '@xpo-ltl/sdk-common';

export const BroadcastMessageBeaconType = BeaconTypeCd.MESSAGE;
export const BroadcastMessageBeaconSource = BeaconSourceCd.INSPECTIONS;
export const BroadcastMessagePriority = BeaconPriorityCd.MEDIUM;
